import script from "./OrderDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderDetails.vue?vue&type=script&setup=true&lang=js"

import "./OrderDetails.vue?vue&type=style&index=0&id=29c67bf3&lang=css"

const __exports__ = script;

export default __exports__